<template>
    <div class="admin-notifications">
      <h1>通知管理 <span style="color:Red"> 部分待實裝</span></h1>
      <table>
        <thead>
          <tr>
            <!-- <th class="hide-on-mobile">通知類型</th> -->
            <th>通知名稱</th>
            <!-- <th>Email通知</th>
            <th>後台通知</th> -->
            <th>Telegram通知</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="setting in settings" :key="setting.id">
            <!-- <td class="hide-on-mobile">{{ setting.setting_type }}</td> -->
            <td>{{ setting.setting_name }}</td>
            <!-- <td>
              <label class="switch">
                <input
                  type="checkbox"
                  :checked="!!setting.is_mail"
                  @change="toggleSetting(setting, 'is_mail', $event.target.checked)"
                />
                <span class="slider"></span>
              </label>
            </td>
            <td>
              <label class="switch">
                <input
                  type="checkbox"
                  :checked="!!setting.is_admin"
                  @change="toggleSetting(setting, 'is_admin', $event.target.checked)"
                />
                <span class="slider"></span>
              </label>
            </td> -->
            <td>
              <label class="switch">
                <input
                  type="checkbox"
                  :checked="!!setting.is_telegram"
                  @change="toggleSetting(setting, 'is_telegram', $event.target.checked)"
                />
                <span class="slider"></span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script setup>
  import {  onBeforeMount , defineOptions, ref, onMounted } from 'vue'
  import axios from 'axios'
  import Swal from 'sweetalert2'
  import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'
  import { useRouter } from 'vue-router'
  const router = useRouter()
    // 取得 store
    const useAdminSysTemp = useAdminSysTempStore()

  onBeforeMount(async () => {
  // 檢查是否登入
  await useAdminSysTemp.fetchAdminCheckLogin()
  if (!useAdminSysTemp.isLoggedIn) {
    router.push('/admin/login')
    return
  }
})

  defineOptions({
    name: 'AdminNotificationsPage'
  })
  


  const settings = ref([])
  
  // 載入通知設定
  onMounted(async () => {
    try {
      const resp = await axios.get('/api/admin/loadNotificationsSettings')
      if (resp.data.success) {
        settings.value = resp.data.notificationsSettings
      } else {
        alert(resp.data.message)
      }
    } catch (error) {
      console.error(error)
       //error icon
       Swal.fire({
                        icon: 'error',
                        title: '錯誤',
                        text: '載入通知設定失敗',
                        timer: 2000
                    });
    }
  })
  
        // 前端
        const toggleSetting = async (setting, field, value) => {
        try {
            const resp = await axios.post('/api/admin/updateNotificationSetting', {
            setting_type: setting.setting_type,      // 關鍵：帶 id
            field,               // 欲更新的欄位名稱
            value                // 欲更新的值 (true/false)
            })
            if (resp.data.success) {
            setting[field] = value ? 1 : 0
            } else {
                Swal.fire({
                icon: 'error',
                title: '錯誤',
                text: '更新通知設定失敗',
                timer: 2000
                });
            }
        } catch (error) {
            console.error(error)
            Swal.fire({
            icon: 'error',
            title: '錯誤',
            text: '載入通知設定失敗',
            timer: 2000
            });
        }
        }

  </script>
  
  <style scoped>
  .admin-notifications {
    background-color: #fafafa;
    padding: 1rem;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  /* 讓表格欄位置中 */
  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;     /* 水平置中 */
    vertical-align: middle; /* 垂直置中 */
  }
  
  /* 標題列背景色 */
  th {
    background-color: #f2f2f2;
  }
  
  /* Toggle Switch 核心樣式 */
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
  }
  
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0; 
    left: 0; 
    right: 0; 
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
  
  input:checked + .slider {
    background-color: #2196F3;
  }
  
  input:checked + .slider:before {
    transform: translateX(24px);
  }

  /* ============ 手機版隱藏欄位 ============ */
.hide-on-mobile {
  /* 預設顯示 */
  display: table-cell; 
}

@media (max-width: 768px) {
  .hide-on-mobile {
    display: none; /* 手機版隱藏 */
  }
}
  </style>
  